import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeRepairRequestCommand } from './serialize';

/**
 * 成立報修單：DRAFT → IN_PROGRESS。
 * POST `/aftersales/repair-request/{id}/establish`。
 * body 僅 `{ updatedAt }`。成功後每筆明細建立 PENDING 維修品，並寫入 productCode／itemName 快照。
 *
 * @param {string} id
 * @param {{ updatedAt?: string, record?: { updatedAt?: string } }} [payload]
 */
export async function establishRepairRequest(id, payload = {}) {
  const { data: raw } = await request.post(
    `/aftersales/repair-request/${id}/establish`,
    serializeRepairRequestCommand(payload),
  );
  return parseVer4DetailResponse(raw);
}
